// ABOUTME: Dispatches a JobSectionId to the component that renders that overview section.
// ABOUTME: Each section decides on its own whether it has anything to show.

import { JobPresentation, JobPresentationContext, JobSectionId } from '../../../../registry';
import { DetailType } from '../../../../types';
import { JobCountersSection } from './JobCountersSection';
import { JobFilesSection } from './JobFilesSection';

interface IJobOverviewSectionProps {
    section: JobSectionId;
    presentation: JobPresentation;
    ctx: JobPresentationContext;
    handleToggleDetails: (title: DetailType) => void;
}

export function JobOverviewSection(props: Readonly<IJobOverviewSectionProps>) {
    const { section, presentation, ctx, handleToggleDetails } = props;
    const { job } = ctx;

    switch (section) {
        case 'counters':
            return (
                <JobCountersSection
                    presentation={presentation}
                    ctx={ctx}
                    handleToggleDetails={handleToggleDetails}
                />
            );
        case 'files':
            return <JobFilesSection job={job} />;
        default:
            return null;
    }
}
